import React, { useState, useCallback, useContext } from 'react';
import { sendAddPaymentEvent } from 'snowplow';
import { PureTranslator } from 'ggApp/modules/translator';
import { InfoCard, CARD_TYPE } from 'ggApp/modules/newCheckout/components/InfoCard';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';

import Plus from 'ggApp/shared/icons/CleanPlus';

import {
    Wrap,
    Title,
    PaymentMethodsWrap,
    AddNewButton,
    ControlsWrap,
    BackButton,
    ContinueButton,
    AddLabel,
} from './styles';

const Select = ({ currentPaymentMethods, paymentMethod }) => {
    const { send, orderNumber, user, activeStore } = useContext(OrderContext);
    const [selectedPaymentMethodIndex, selectPaymentMethodIndex] = useState(0);
    const hasExistingOrderPaymentMethod = paymentMethod && paymentMethod.id;

    const updateActivePayment = useCallback(() => {
        const { id, type, billingAccountId } = currentPaymentMethods[selectedPaymentMethodIndex];
        send('CHANGE', {
            paymentMethodId: id,
            paymentMethodType: type,
            billingAccountId,
        });
    }, [send, currentPaymentMethods, selectedPaymentMethodIndex]);

    const handleBackButton = useCallback(() => {
        send('BACK');
    }, [send]);

    const handleAddButtonClick = useCallback(() => {
        sendAddPaymentEvent({
            eventProperty: {
                store: activeStore.code,
                orderID: orderNumber,
                userID: user.id,
            },
        });

        send('CREATE');
    }, [send, orderNumber, user, activeStore]);

    return (
        <Wrap data-testid="select-payment-step">
            <Title>
                <PureTranslator tk="NEW_CHECKOUT_SELECT_PAYMENT_TITLE" />
            </Title>

            <PaymentMethodsWrap>
                {currentPaymentMethods &&
                    currentPaymentMethods.map((method, index) => (
                        <InfoCard
                            key={method?.id || index}
                            readOnly
                            type={CARD_TYPE.payment}
                            payment={method}
                            active={index === selectedPaymentMethodIndex}
                            setActive={() => selectPaymentMethodIndex(index)}
                        />
                    ))}
            </PaymentMethodsWrap>

            <AddNewButton icon={<Plus />} small onClick={handleAddButtonClick}>
                <AddLabel>
                    <PureTranslator tk="NEW_CHECKOUT_SELECT_PAYMENT_ADD_NEW" />
                </AddLabel>
            </AddNewButton>

            <ControlsWrap>
                <BackButton
                    outlined
                    type="button"
                    isDisabled={!hasExistingOrderPaymentMethod}
                    onClick={handleBackButton}
                >
                    <PureTranslator tk="NEW_CHECKOUT_HOME_BACK_BTN" />
                </BackButton>

                <ContinueButton fullWidth type="button" onClick={updateActivePayment}>
                    <PureTranslator tk="NEW_CHECKOUT_HOME_CONTINUE_BTN" />
                </ContinueButton>
            </ControlsWrap>
        </Wrap>
    );
};

export default Select;
